// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ca0f3a65","453":"d952c3fb","455":"84baab1c"}[chunkId] + ".chunk.js";
};